import { AbstractIdbaModel } from "src/app/shared/models/abstract-idba-model";

export class Portador extends AbstractIdbaModel {

    public override display(self: any): string {
        return self.nomePessoa;
    }
    public override displayCodigo(self: any): string {
        throw new Error("Method not implemented.");
    }
    public override displayNome(self: any): string {
        throw new Error("Method not implemented.");
    }
    public override convertToModel(data: any): Portador {
        return new Portador(data);
    }
    public override filter(value: string, objectList: any[]): any[] {
        const filterValue = value.toLowerCase();
        return objectList.filter((item) =>
            (item.nomePessoa).toString().trim().toLowerCase().includes(filterValue)
        );
    }

    codigoPessoa: number;
    idTipoPortador: number;
    nomePessoa: string;
    nomeBanco: string;
    agencia: number;
    carteira: string;
    cedente: string;
    contaCorrente: number;
    digitoAgência: number;
    digitoContaCorrente: number;
    fimFaixa: number;
    idBanco: number;
    idPortador: number;
    iniFaixa: number;
    jurosDiarios: number;
    nome: string;
    posto: number;
    programaBoletos: string;
    remessa: number;
    numDiasAtrasoBloqueio: number;
    numDiasProtestoBanco: number;
}